module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VGF02-a55ae94969ce7f8b7b064b9534327f7d.png";